import './product.1_3_6_SNS_FLAVOR_V3';